import { AppointmentMoment } from '../shared/appointment-moment'

export class AddAppointmentRequest {
  constructor(
  public moment : AppointmentMoment,
  public hairdresser : string,
  public longHair : boolean,
  public highlights : boolean,
  public serviceName : string,
  public customerGuid : string,
  public name : string)
  {}
}

export class AddAppointmentResult {
  public appointmentId : string;
}
